var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BRow',[_c('ul',{staticClass:"mb-0",class:_vm.$isWealthTime ? 'summary-banner-action-bar' : 'mobile-nav'},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }